'use strict';

var Inflections = require('../var/Inflections');

function getHumanWord(str) {
  // istanbul ignore next
  return Inflections.human && Inflections.human.find(str);
}

module.exports = getHumanWord;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/getHumanWord.js
// module id = 447
// module chunks = 0